import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import MuiSelect from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import useSx from "./Select.styles";
const Select = forwardRef(({ name, value, label, description, values, labels, itemStyles, selectedStyle, onChange, disabled, disabledWhenFilled, "data-test": dataTest, ...props }, ref) => {
    const sx = useSx({ selectedStyle, disabledWhenFilled });
    return (_jsxs(FormControl, { sx: sx.formControl, children: [_jsx(InputLabel, { children: label }), _jsx(MuiSelect, { inputRef: ref, sx: sx.select, name: name, size: "small", label: label, value: value || "", onChange: onChange, disabled: disabled || disabledWhenFilled, 
                // add the 'data-test' attribute, falling back to the name by default
                // Since data-test is not a native attribute to the inner component (which is a div),
                // we need to cast it to the type of the inner component
                SelectDisplayProps: {
                    ...(dataTest || name ? { "data-test": dataTest || name } : {}),
                }, 
                // add the 'select-popover' class for e2e tests
                MenuProps: { PopoverClasses: { root: "select-popover" } }, ...props, children: values.map((value, i) => {
                    let val = value;
                    let disabled = false;
                    // if the value is an array
                    if (Array.isArray(value)) {
                        // get the value and the 'disabled' flag from the array
                        [val, disabled] = value;
                    }
                    const itemStyle = itemStyles && itemStyles[i] ? itemStyles[i] : {};
                    return (_jsx(MenuItem, { value: val, disabled: disabled, sx: itemStyle, children: labels[i] }, `val_${i}`));
                }) }), _jsx(FormHelperText, { children: description })] }));
});
export default Select;
